export default {
  getAccessToken(state) {
    return state.accessToken;
  },
  getRefreshToken(state) {
    return state.refreshToken;
  },
  getTagList(state) {
    return state.tagList;
  },
  getShowMenu(state) {
    return state.showMenu;
  },
  getUserSeqId(state) {
    return state.userSeqId;
  },
  getUserName(state) {
    return state.userName;
  },
  getUserEmail(state) {
    return state.userEmail;
  },
  getLanguage(state) {
    return state.language;
  },
  getJobs(state) {
    return state.jobs;
  },
  getTagCodeList(state) {
    const tagCodeList = [];
    for (let ii = 0; ii < state.tagList.length; ii += 1) {
      tagCodeList.push(state.tagList[ii].jobCode);
    }
    return tagCodeList;
  },
  getLoginType(state) {
    return state.loginType;
  },
  getLastSelectedMatchTab(state) {
    return state.lastSelectedMatchTab;
  },

  // 회원가입 시, 사용하는 임시 데이터.
  getTmpUserEmail(state) {
    return state.tmpUserEmail;
  },
  getTmpUserPassword(state) {
    return state.tmpUserPassword;
  },
  getTmpUserNickname(state) {
    return state.tmpUserNickname;
  },
  getTmpUserName(state) {
    return state.tmpUserName;
  },
  getTmpUserBirth(state) {
    return state.tmpUserBirth;
  },
  getTmpUserSex(state) {
    return state.tmpUserSex;
  },
  getTmpUserEducation(state) {
    return state.tmpUserEducation;
  },
  getTmpValidEmailFlag(state) {
    return state.tmpValidEmailFlag;
  },
  getTmpValidPasswordFlag(state) {
    return state.tmpValidPasswordFlag;
  },
  getTmpValidNicknameFlag(state) {
    return state.tmpValidNicknameFlag;
  },
  getTmpValidNameFlag(state) {
    return state.tmpValidNameFlag;
  },
  getTmpTagList(state) {
    return state.tmpTagList;
  },
  getTmpTagNameList(state) {
    const tagNameList = [];
    for (let ii = 0; ii < state.tmpTagList.length; ii += 1) {
      tagNameList.push(state.tmpTagList[ii].jobName);
    }
    return tagNameList;
  },
  getQCnt(state) {
    return state.qCnt;
  },
  getTmpProfileImage(state) {
    return state.tmpProfileImage;
  },
  getProfileImage(state) {
    return state.profileImage;
  },
  getTmpClientId(state) {
    return state.tmpClientId;
  },
};



// WEBPACK FOOTER //
// ./src/store/getters.js